import React, { useState, useEffect } from 'react';
import { useSearchParams, createSearchParams, Link } from 'react-router-dom';
import type { RadioChangeEvent } from 'antd';
import {Button, Avatar, Divider, Input, Typography, Radio} from 'antd';

const { Title } = Typography;

type Props = {
  channels: any,
}

function VideoListFilter(props: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeChannels, setActiveChannels] = useState<string[]>([]);
  const [titleFilters, setTitleFilters] = useState<string>('');
  const [andOr, setAndOr] = useState('and');

  useEffect(() => {
    setActiveChannels(searchParams.getAll('channels'))
  }, []);

  const toggleActiveChannel = (idx: string) => {
    if (activeChannels.includes(idx)){
      setActiveChannels(activeChannels.filter(item => item !== idx))
    } else {
      setActiveChannels([...activeChannels, idx])
    }
  }

  const applyFilter = () => {
    return createSearchParams({
      channels: activeChannels,
      titleFilters: titleFilters.replaceAll("　", " ").split(" "),
      andOr: andOr,
    }).toString()
  };

  const onChangeAndOr = (e: RadioChangeEvent) => {
    console.log('radio checked', e.target.value);
    setAndOr(e.target.value);
  };

  return (
    <div className='VideoListFilter'>
      <Title level={5} type="secondary">チャンネル設定</Title>
      <div>
        {
          Object.keys(props.channels).map(key => {
            const opacity = activeChannels.includes(props.channels[key].idx) ? 1.0 : 0.2;
            return  <Avatar
                      key={key}
                      src={props.channels[key].channelIcon}
                      style={{cursor: 'pointer', opacity: opacity}}
                      onClick={()=>{toggleActiveChannel(props.channels[key].idx)}}
                    />
          })
        }
      </div>
      <Divider/>
      <div>
        <Title level={5} type="secondary">タイトル検索</Title>
        <Radio.Group onChange={onChangeAndOr} value={andOr}>
          <Radio value={"and"}>and</Radio>
          <Radio value={"or"}>or</Radio>
        </Radio.Group>
        <Input
          placeholder="スペース区切りで検索"
          value={titleFilters}
          onChange={(event) => setTitleFilters(event.target.value)}
        />
      </div>
      <Divider/>
      <div>
        <Button type='primary'><Link to={`/?${applyFilter()}`} reloadDocument>適用する</Link></Button>
      </div>

    </div>
  )
}

export default VideoListFilter
